/* GRADA Theme — theme.js (ES2020, no build step) */

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

document.addEventListener('DOMContentLoaded', function () {

  /* ============================================================
     0. AGE GATE
     ============================================================ */
  (function () {
    var gate = document.querySelector('[data-age-gate]');
    if (!gate) return;

    var storageKey = 'modal_dismissed_age';
    var denied = gate.querySelector('[data-age-denied]');
    var accept = gate.querySelector('[data-age-accept]');
    var deny = gate.querySelector('[data-age-deny]');
    var previousOverflow = '';

    function readDismissed() {
      try {
        return Boolean(window.localStorage.getItem(storageKey));
      } catch (e) {
        return false;
      }
    }

    function openGate() {
      previousOverflow = document.body.style.overflow;
      gate.hidden = false;
      gate.style.display = '';
      document.body.style.overflow = 'hidden';
      window.setTimeout(function () {
        gate.focus();
      }, 0);
    }

    function closeGate() {
      gate.hidden = true;
      gate.style.display = 'none';
      document.body.style.overflow = previousOverflow;
    }

    if (readDismissed()) {
      closeGate();
      window.dispatchEvent(new CustomEvent('grada:age-verified', {
        detail: { acceptedAt: window.localStorage.getItem(storageKey) }
      }));
    } else {
      openGate();
    }

    if (accept) {
      accept.addEventListener('click', function () {
        var acceptedAt = new Date().toISOString();
        try {
          window.localStorage.setItem(storageKey, acceptedAt);
        } catch (e) {}
        window.dispatchEvent(new CustomEvent('grada:age-verified', { detail: { acceptedAt: acceptedAt } }));
        closeGate();
      });
    }

    if (deny) {
      deny.addEventListener('click', function () {
        if (denied) denied.hidden = false;
      });
    }
  })();

  /* ============================================================
     1. HEADER SCROLL
     ============================================================ */
  (function () {
    var header = document.querySelector('.grada-header');
    if (!header) return;

    var solidDefault = header.getAttribute('data-solid-default') === 'true';

    function onScroll() {
      if (solidDefault || window.scrollY > 640) {
        header.classList.add('grada-header--solid');
      } else {
        header.classList.remove('grada-header--solid');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();


  /* ============================================================
     2. MOBILE MENU
     ============================================================ */
  (function () {
    var header = document.querySelector('.grada-header');
    var menu = document.querySelector('.grada-header__mobile-menu');
    var mobileItems = document.querySelectorAll('.grada-header__mobile-link');
    mobileItems.forEach(function (item, index) {
      item.style.setProperty('--item-index', index);
    });

    function closeMenu() {
      if (header) header.classList.remove('is-menu-open');
      if (menu) {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
      }
      document.querySelectorAll('[data-menu-toggle]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      });
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = header && header.classList.toggle('is-menu-open');
        if (menu) {
          menu.classList.toggle('is-open', Boolean(isOpen));
          menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        }
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.body.style.overflow = isOpen ? 'hidden' : '';
      });
    });

    document.querySelectorAll('.grada-header__mobile-link, .grada-header__mobile-secondary-link').forEach(function (link) {
      link.addEventListener('click', function () {
        closeMenu();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && header && header.classList.contains('is-menu-open')) {
        closeMenu();
      }
    });
  })();


  /* ============================================================
     3. CART DRAWER
     ============================================================ */
  (function () {
    var cart = document.querySelector('.grada-cart');
    if (!cart) return;

    var itemsContainer = cart.querySelector('.grada-cart__items');
    var footer = cart.querySelector('.grada-cart__footer');
    var subtotalEl = cart.querySelector('[data-cart-subtotal]');
    var backdrop = cart.querySelector('.grada-cart__backdrop');

    function openCart() {
      cart.classList.add('is-open');
      cart.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      fetchAndRender();
    }

    function closeCart() {
      cart.classList.remove('is-open');
      cart.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function fetchAndRender() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (data) { renderCart(data); })
        .catch(function (err) { console.error('GRADA: cart fetch error', err); });
    }

    function renderCart(data) {
      if (!itemsContainer) return;
      itemsContainer.innerHTML = '';

      var items = data.items || [];
      var isEmpty = items.length === 0;

      if (itemsContainer) itemsContainer.style.display = isEmpty ? 'none' : '';
      if (footer) footer.style.display = '';
      document.querySelectorAll('[data-cart-count]').forEach(function (countEl) {
        countEl.textContent = String(data.item_count || 0);
      });

      items.forEach(function (item, i) {
        var el = document.createElement('li');
        el.className = 'grada-cart__item';

        var imageEl = document.createElement('div');
        imageEl.className = 'grada-cart__item-image';
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title || '';
          img.loading = 'lazy';
          imageEl.appendChild(img);
        }

        var infoEl = document.createElement('div');
        infoEl.className = 'grada-cart__item-details';

        var topEl = document.createElement('div');
        topEl.className = 'grada-cart__item-top';

        var titleEl = document.createElement('p');
        titleEl.className = 'grada-cart__item-title';
        titleEl.textContent = item.title || '';

        var priceEl = document.createElement('p');
        priceEl.className = 'grada-cart__item-price';
        priceEl.textContent = formatMoney(item.final_line_price);

        topEl.appendChild(titleEl);
        topEl.appendChild(priceEl);
        infoEl.appendChild(topEl);

        var metaEl = document.createElement('p');
        metaEl.className = 'grada-cart__item-meta';
        metaEl.textContent = item.variant_title || item.product_type || '';
        if (metaEl.textContent) infoEl.appendChild(metaEl);

        var removeBtn = document.createElement('button');
        removeBtn.className = 'grada-cart__remove';
        removeBtn.setAttribute('data-cart-remove', '');
        removeBtn.setAttribute('data-line', i + 1);
        removeBtn.setAttribute('aria-label', 'Remove ' + (item.title || 'item'));
        removeBtn.textContent = 'Remove';

        var quantityEl = document.createElement('div');
        quantityEl.className = 'grada-cart__quantity';
        quantityEl.setAttribute('aria-label', (item.title || 'Item') + ' quantity');

        var decreaseBtn = document.createElement('button');
        decreaseBtn.type = 'button';
        decreaseBtn.setAttribute('data-cart-quantity', '');
        decreaseBtn.setAttribute('data-line', i + 1);
        decreaseBtn.setAttribute('data-quantity', String(Math.max(0, (item.quantity || 0) - 1)));
        decreaseBtn.setAttribute('aria-label', 'Decrease ' + (item.title || 'item'));
        decreaseBtn.textContent = '-';

        var quantityCount = document.createElement('span');
        quantityCount.textContent = String(item.quantity || 0);

        var increaseBtn = document.createElement('button');
        increaseBtn.type = 'button';
        increaseBtn.setAttribute('data-cart-quantity', '');
        increaseBtn.setAttribute('data-line', i + 1);
        increaseBtn.setAttribute('data-quantity', String((item.quantity || 0) + 1));
        increaseBtn.setAttribute('aria-label', 'Increase ' + (item.title || 'item'));
        increaseBtn.textContent = '+';

        quantityEl.appendChild(decreaseBtn);
        quantityEl.appendChild(quantityCount);
        quantityEl.appendChild(increaseBtn);

        var actionsEl = document.createElement('div');
        actionsEl.className = 'grada-cart__item-actions';
        actionsEl.appendChild(quantityEl);
        actionsEl.appendChild(removeBtn);

        infoEl.appendChild(actionsEl);
        el.appendChild(imageEl);
        el.appendChild(infoEl);
        itemsContainer.appendChild(el);
      });

      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(data.total_price);
      }

      bindRemoveButtons();
      bindQuantityButtons();
    }

    function bindRemoveButtons() {
      cart.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.getAttribute('data-line');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: Number(line), quantity: 0 })
          })
            .then(function (r) { return r.json(); })
            .then(function (data) { renderCart(data); })
            .catch(function (err) { console.error('GRADA: cart remove error', err); });
        });
      });
    }

    function bindQuantityButtons() {
      cart.querySelectorAll('[data-cart-quantity]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.getAttribute('data-line');
          var quantity = btn.getAttribute('data-quantity');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
          })
            .then(function (r) { return r.json(); })
            .then(function (data) { renderCart(data); })
            .catch(function (err) { console.error('GRADA: cart quantity error', err); });
        });
      });
    }

    /* Open triggers */
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openCart(); });
    });

    if (backdrop) {
      backdrop.addEventListener('click', function () { closeCart(); });
    }

    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeCart(); });
    });

    document.addEventListener('grada:cart-open', function () { openCart(); });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && cart.classList.contains('is-open')) {
        closeCart();
      }
    });

    document.addEventListener('grada:cart-add', function (e) {
      var variantId = e.detail && e.detail.variantId;
      var quantity = (e.detail && e.detail.quantity) || 1;
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('grada:cart-open'));
        })
        .catch(function (err) { console.error('GRADA: cart add error', err); });
    });
  })();


  /* ============================================================
     4. ADD TO CART BUTTONS
     ============================================================ */
  (function () {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        document.dispatchEvent(new CustomEvent('grada:cart-add', {
          detail: { variantId: variantId, quantity: 1 }
        }));
      });
    });
  })();


  /* ============================================================
     5. ACCORDION
     ============================================================ */
  (function () {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-accordion-item]');
        if (!item) return;

        var group = item.closest('.grada-accordion');
        var isOpen = item.getAttribute('data-open') === 'true';

        /* Close siblings in the same group */
        if (group) {
          group.querySelectorAll('[data-accordion-item][data-open="true"]').forEach(function (openItem) {
            if (openItem !== item) {
              openItem.setAttribute('data-open', 'false');
              var siblingTrigger = openItem.querySelector('[data-accordion-trigger]');
              if (siblingTrigger) siblingTrigger.setAttribute('aria-expanded', 'false');
            }
          });
        }

        var nextState = isOpen ? 'false' : 'true';
        item.setAttribute('data-open', nextState);
        trigger.setAttribute('aria-expanded', nextState);
      });
    });
  })();


  /* ============================================================
     6. FAQ TABS
     ============================================================ */
  (function () {
    document.querySelectorAll('[data-faq-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabValue = tab.getAttribute('data-faq-tab');
        var tabParent = tab.closest('.grada-faq-tabs__tab');
        var tabsContainer = tabParent ? tabParent.parentElement : null;

        /* Deactivate siblings */
        if (tabsContainer) {
          tabsContainer.querySelectorAll('[data-faq-tab]').forEach(function (sibling) {
            sibling.setAttribute('data-active', 'false');
          });
        }
        tab.setAttribute('data-active', 'true');

        /* Show/hide panels */
        var section = tab.closest('[class*="grada-faq-tabs"]') || document;
        var panels = (section === document ? document : section.closest('section') || document)
          .querySelectorAll('.grada-faq-tabs__panel');

        /* Broaden scope if nothing found */
        if (!panels.length) {
          panels = document.querySelectorAll('.grada-faq-tabs__panel');
        }

        panels.forEach(function (panel) {
          panel.style.display = panel.getAttribute('data-tab') === tabValue ? '' : 'none';
        });
      });
    });
  })();


  /* ============================================================
     7. PDP GALLERY SCROLL-SNAP DOTS
     ============================================================ */
  (function () {
    var rail = document.querySelector('.grada-pdp-gallery__rail');
    var dotsContainer = document.querySelector('.grada-pdp-gallery__dots');
    if (!rail || !dotsContainer) return;

    var dots = dotsContainer.querySelectorAll('span');
    var activeIndex = 0;

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      activeIndex = index;
    }

    rail.addEventListener('scroll', function () {
      var width = rail.clientWidth;
      if (!width) return;
      var index = Math.round(rail.scrollLeft / width);
      if (index !== activeIndex) setActiveDot(index);
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        rail.scrollTo({ left: i * rail.clientWidth, behavior: 'smooth' });
        setActiveDot(i);
      });
    });

    setActiveDot(0);
  })();


  /* ============================================================
     8. COOKIE CONSENT
     ============================================================ */
  (function () {
    var panel = document.querySelector('.grada-cookie-panel');
    if (!panel) return;

    var ageStorageKey = 'modal_dismissed_age';
    var storageKey = 'grada.cookieConsent';
    var cookieName = 'grada_cookie_consent';
    var waitingForAge = false;

    function readConsent() {
      var stored = null;
      try {
        stored = localStorage.getItem(storageKey);
      } catch (e) {
        stored = null;
      }

      if (stored === 'accepted' || stored === 'rejected') return stored;

      var cookie = document.cookie
        .split('; ')
        .filter(function (value) { return value.indexOf(cookieName + '=') === 0; })[0];

      return cookie ? cookie.split('=')[1] : null;
    }

    function writeConsent(status) {
      try {
        localStorage.setItem(storageKey, status);
      } catch (e) {}
      document.cookie = cookieName + '=' + status + '; Max-Age=31536000; Path=/; SameSite=Lax';
      window.dispatchEvent(new CustomEvent('grada:cookie-consent', { detail: { status: status } }));
    }

    function closePanel() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    }

    function openPanel() {
      panel.style.display = '';
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
    }

    function ageVerified() {
      try {
        return Boolean(localStorage.getItem(ageStorageKey));
      } catch (e) {
        return false;
      }
    }

    if (readConsent()) {
      panel.style.display = 'none';
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    } else if (ageVerified()) {
      openPanel();
    } else {
      waitingForAge = true;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    }

    document.querySelectorAll('[data-cookie-accept]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        writeConsent('accepted');
        closePanel();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) {
        closePanel();
      }
    });

    window.addEventListener('grada:age-verified', function () {
      if (waitingForAge && !readConsent()) {
        waitingForAge = false;
        openPanel();
      }
    });
  })();


  /* ============================================================
     9. REVEAL ON SCROLL
     ============================================================ */
  (function () {
    var revealEls = document.querySelectorAll('.reveal');
    if (!revealEls.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealEls.forEach(function (el) { observer.observe(el); });
  })();


  /* ============================================================
     10. MARQUEE PAUSE ON HOVER
     ============================================================ */
  (function () {
    var selectors = [
      '.grada-ticker__track',
      '.grada-home-marquee__track',
      '.grada-home-review-band__track',
      '.grada-shop-reviews__track',
      '.grada-instagram-strip__track'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (track) {
        track.addEventListener('mouseenter', function () {
          track.style.animationPlayState = 'paused';
        });
        track.addEventListener('mouseleave', function () {
          track.style.animationPlayState = 'running';
        });
      });
    });
  })();

});
